// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ScenarioLayer } from "./ScenarioLayer";
import {
  ScenarioLayerFromJSON,
  ScenarioLayerFromJSONTyped,
  ScenarioLayerToJSON,
  ScenarioLayerToJSONTyped,
} from "./ScenarioLayer";
import type { Simulation } from "./Simulation";
import {
  SimulationFromJSON,
  SimulationFromJSONTyped,
  SimulationToJSON,
  SimulationToJSONTyped,
} from "./Simulation";
import type { Schematisation } from "./Schematisation";
import {
  SchematisationFromJSON,
  SchematisationFromJSONTyped,
  SchematisationToJSON,
  SchematisationToJSONTyped,
} from "./Schematisation";
import type { SpatialExtent } from "./SpatialExtent";
import {
  SpatialExtentFromJSON,
  SpatialExtentFromJSONTyped,
  SpatialExtentToJSON,
  SpatialExtentToJSONTyped,
} from "./SpatialExtent";
import type { BoundedGridWithOptionalAxes } from "./BoundedGridWithOptionalAxes";
import {
  BoundedGridWithOptionalAxesFromJSON,
  BoundedGridWithOptionalAxesFromJSONTyped,
  BoundedGridWithOptionalAxesToJSON,
  BoundedGridWithOptionalAxesToJSONTyped,
} from "./BoundedGridWithOptionalAxes";

/**
 *
 * @export
 * @interface ScenarioMeta
 */
export interface ScenarioMeta {
  /**
   *
   */
  id?: string | null;
  /**
   *
   */
  schematisation: Schematisation;
  /**
   *
   */
  simulation: Simulation;
  /**
   *
   */
  extent?: SpatialExtent | null;
  /**
   *
   */
  grid?: BoundedGridWithOptionalAxes | null;
  /**
   *
   */
  layers?: Array<ScenarioLayer>;
  /**
   * A spatial bounding box of 4 floats (x1, y1, x2, y2). For WGS84 we use traditional (x=lon, y=lat) order.
   */
  envelope?: Array<number> | null;
  /**
   *
   */
  managementUrl?: string | null;
}

/**
 * Check if a given object implements the ScenarioMeta interface.
 */
export function instanceOfScenarioMeta(value: object): value is ScenarioMeta {
  if (!("schematisation" in value) || value["schematisation"] === undefined) return false;
  if (!("simulation" in value) || value["simulation"] === undefined) return false;
  return true;
}

export function ScenarioMetaFromJSON(json: any): ScenarioMeta {
  return ScenarioMetaFromJSONTyped(json, false);
}

export function ScenarioMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScenarioMeta {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : json["id"],
    schematisation: SchematisationFromJSON(json["schematisation"]),
    simulation: SimulationFromJSON(json["simulation"]),
    extent:
      json["extent"] === undefined
        ? undefined
        : json["extent"] === null
        ? null
        : SpatialExtentFromJSON(json["extent"]),
    grid:
      json["grid"] === undefined
        ? undefined
        : json["grid"] === null
        ? null
        : BoundedGridWithOptionalAxesFromJSON(json["grid"]),
    layers:
      json["layers"] == null
        ? undefined
        : (json["layers"] as Array<any>).map(ScenarioLayerFromJSON),
    envelope:
      json["envelope"] === undefined
        ? undefined
        : json["envelope"] === null
        ? null
        : json["envelope"],
    managementUrl:
      json["management_url"] === undefined
        ? undefined
        : json["management_url"] === null
        ? null
        : json["management_url"],
  };
}

export function ScenarioMetaToJSON(json: any): ScenarioMeta {
  return ScenarioMetaToJSONTyped(json, false);
}

export function ScenarioMetaToJSONTyped(
  value?: ScenarioMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    schematisation: SchematisationToJSON(value["schematisation"]),
    simulation: SimulationToJSON(value["simulation"]),
    extent: SpatialExtentToJSON(value["extent"]),
    grid: BoundedGridWithOptionalAxesToJSON(value["grid"]),
    layers:
      value["layers"] == null
        ? undefined
        : (value["layers"] as Array<any>).map(ScenarioLayerToJSON),
    envelope: value["envelope"],
    management_url: value["managementUrl"],
  };
}
